import { PayloadAction } from "@reduxjs/toolkit";
import { createAppSlice } from "./app/createAppSlice";

export type IActiveProjectTab = "design" | "room" | "settings" | null;

export interface IGlobalState {
  activeProjectTab: IActiveProjectTab;
  accessToken: string | null;
  expiresOn?: string | null;
}

const initialState: IGlobalState = {
  activeProjectTab: null,
  accessToken: null,
  expiresOn: null,
};

export const globalSlice = createAppSlice({
  name: "global",
  initialState,
  reducers: {
    setActiveProjectTabInRedux(state, action: PayloadAction<IGlobalState["activeProjectTab"]>) {
      state.activeProjectTab = action.payload;
    },
    setAccessToken(
      state,
      action: PayloadAction<{ accessToken: string | null; expiresOn?: string | null }>
    ) {
      state.accessToken = action.payload.accessToken;
      state.expiresOn = action.payload.expiresOn;
    },
    clearAccessToken(state) {
      state.accessToken = null;
      state.expiresOn = null;
    },
  },
});

export const { setActiveProjectTabInRedux, setAccessToken, clearAccessToken } = globalSlice.actions;

export default globalSlice.reducer;
